import { Component, OnInit, ViewChild, Injectable } from '@angular/core';
import { MarketService } from '../../api/services/market.service';
import { NgbModal, NgbDateStruct, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PreferencesService } from '../../api/services/preferences.service';
import { AuthService } from '../../api/services/auth.service';
import { ProjectService } from '../../api/services/project.services';
import { ActivatedRoute } from '@angular/router';
import { Address } from '../../api/models/address';
import { BomLine } from '../../api/models/bom-line';
import { BomTableService } from '../bom-table/bom-table.service';
import { UserService } from '../../api/services/user.service';
import { Quote, ShipViaOptionDto } from '../../api/models/quote';
import { Worksheet } from '../../api/models/worksheet';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { DownloadCopyComponent } from '../order-worksheet/download-copy/download-copy.component';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { ProductAliasService } from '../../api/services/product-alias.service';
import { BomTableRow } from '../../api/models/bom-table-row';
import { OrderDetail, ShippingAndHandling } from '../../api/models/order-detail';
import { Subject } from 'rxjs/Subject';
import { Market } from '../../api/models/market-model';
import { NgModel } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { OrderAddressChangeModalComponent } from '../order-address-change-modal/order-address-change-modal.component';
import { MarketBannerService } from '../market-banner/market-banner.service';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      let today = new Date();
      let yearPrefix = today.getFullYear() + '';
      date[2] = yearPrefix.slice(0,2) + date[2];
      return {
        day : parseInt(date[1], 10),
        month : parseInt(date[0], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    if(date) {
      let year = date.year + '';
    let day = date.day < 10 ? '0' + date.day : date.day;
    let month = date.month < 10 ? '0' + date.month : date.month;
    return month + this.DELIMITER + day + this.DELIMITER + year.slice(-2);
    } else {
      return '';
    }
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      let today = new Date();
      let yearPrefix = today.getFullYear() + '';
      date[2] = yearPrefix.slice(0,2) + date[2];
      return {
        day : parseInt(date[1], 10),
        month : parseInt(date[0], 10),
        year : parseInt(date[2], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    if(date) {
      let year = date.year + '';
    let day = date.day < 10 ? '0' + date.day : date.day;
    let month = date.month < 10 ? '0' + date.month : date.month;
    return month + this.DELIMITER + day + this.DELIMITER + year.slice(-2);
    } else {
      return '';
    }
  }
}

@Component({
  selector: 'app-order-detail-view',
  templateUrl: './order-detail-view.component.html',
  styleUrls: ['./order-detail-view.component.scss'],
  providers: [
    /**
     * This 2 provider are only for this component and not for the app module.
     * This is because we cannot provide dynamic date format and if we put it in app module
     * then all date picker will follow the MM/DD/YY format
     */
    {provide: NgbDateAdapter, useClass: CustomAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ]
})
export class OrderDetailViewComponent implements OnInit {

  totalPrice = 0;
  loading = true;
  skuDetailLoading = true;

  bomItems: BomTableRow[] = [];
  worksheet: Worksheet;
  bomData: BomLine[];

  quote: Quote;
  showBomTable = false;

  order: string;
  quoteDetailsHash: any;
  step: number;

  roles: string[] = [];

  addresses: Address[];

  marketAddresses: Address[];

  toBeDetermined = false;

  selectedAddress: Address;

  selectedSecondaryAddress: Address;

  worksheetMarketId: string;

  worksheetId: string;

  deliveryOptions: ShipViaOptionDto[] = [];

  options = [1, 2, 3, 4];

  codeSelected = '1';

  projectNumber: string;

  errorSubmittingQuote = false;
  warningSubmittingquote = false;

  organizationId: string;

  submittingQuote = false;

  submittingOrder = false;

  canViewPricing = false;

  serverError: [boolean, string] = [false, ''];

  quoteServerError = false;

  paymentServerError = false;

  isAtc = false;
  isVerizon: boolean = false;

  deliveryOptionsError = false;

  roleRequest: RoleRequest;

  minDate: NgbDateStruct;
  deliveryDateChange = false;

  orderDetail: OrderDetail;
  shippingAndHandling: ShippingAndHandling;
  market: Market;
  errorMessages$: Subject<string[]> = new Subject();

  //For Verizon only
  VERIZON_DATE_FORMAT_REGEX = '(0[1-9]|1[012])/(0[1-9]|[12][0-9]|3[01])/([0-9]{2})';
  @ViewChild('gerf') gerf:NgModel;
  @ViewChild('gera') gera:NgModel;
  @ViewChild('mrd') mrd:NgModel;

  grpEquipRecvdF: string;
  grpEquipRecvdA: string;
  mrDate: string;

  isTesscoAdmin: boolean = false;
  backToSearch: string;

  constructor(private marketService: MarketService,
    private preferencesService: PreferencesService,
    private authService: AuthService,
    private projectService: ProjectService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private bomTableService: BomTableService,
    private productAliasService: ProductAliasService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private marketBannerService: MarketBannerService,

  ) { }


  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params => {
      this.backToSearch = params['backToSearch'];
    });
    
    this.activatedRoute
      .params.map(p => p.id)
      .switchMap(id => {
        this.worksheetId = id;
        return this.projectService.getWorksheet(id);
      })
      .switchMap(worksheet => {
        this.worksheet = worksheet;
        return this.projectService.getQuoteV2(this.worksheet.id);
      })
      .switchMap(quote => {
        this.orderDetail = quote;
        // this.selectedShipViaOption = quote.shipViaOptions.pop();
        this.shippingAndHandling = quote.shippingAndHandling;
        this.preferencesService.getPreferences('CUSTOMER', this.worksheet.project.organizationId).subscribe(prefs => {
          this.isAtc = prefs['special-fields'].Value === 'ATC';
          this.isVerizon = prefs['special-fields'].Value === 'Verizon eQuote';
          if (this.isVerizon) {
            this.preferencesService.getPreferences('WORKSHEET', this.worksheet.id).subscribe(pref => {
              if (pref) {
                this.grpEquipRecvdF = pref['group-equipment-received-f-date'] ? pref['group-equipment-received-f-date'].Value : null;
                this.grpEquipRecvdA = pref['group-equipment-received-a-date'] ? pref['group-equipment-received-a-date'].Value : null;
                this.mrDate = pref['mr-date'] ? pref['mr-date'].Value : null;
              }
            });
          }
        });
        if (!this.worksheet.shipToAddressId) {
          this.toBeDetermined = true;
        }
        this.worksheetMarketId = this.worksheet.project.marketId;
        this.organizationId = this.worksheet.project.organizationId;
        
        this.bomTableService.setPricingAndAvailabilityDetails(this.orderDetail.orderLines);
        
        return forkJoin(this.marketService.getMarket(this.worksheetMarketId),
          this.authService.getUserRolesInContext(`WORKSHEET~${this.worksheetId}`),
          this.preferencesService.getPreferences('PROJECT', this.worksheet.projectId));
      })
      .subscribe((data: [Market, string[], any]) => {
        this.market = data[0];
        this.marketBannerService.setMarket(this.market);
        this.addresses = this.market.shippingAddresses;
        this.loading = false;
        this.roles = data[1];
        this.projectNumber = data[2]['oracle-project-number'].Value;
        if (this.worksheet.shipToAddressId) {
          this.marketService.getAddress(this.worksheetMarketId, this.worksheet.shipToAddressId).subscribe(address => {
            this.selectedAddress = address;
            this.toBeDetermined = false;
          }, error => {
            this.selectedAddress = null;
            this.toBeDetermined = true;
          });
        }
        if (this.worksheet.secondaryAddressId) {
          this.marketService.getAddress(this.worksheetMarketId, this.worksheet.secondaryAddressId).subscribe(address => {
            this.selectedSecondaryAddress = address;
          });
        }
      }, error => {
        this.loading = false;
        this.errorMessages$.next(['Error while fetching the order details.']);
      });

    this.roleRequest = new RoleRequest('PRICING_VIEW', null);
    this.roleRequest.setRoleAndContextMap("ADMIN_TESSCO",null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.canViewPricing = roles.getRoleMap('PRICING_VIEW');
      this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
    });
    var today = new Date();
    this.minDate = { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };

    this.bomTableService.$quoteDetailsSubject.subscribe(newValue => {
      this.bomTableService.cleanWaitingItems();
      this.quoteDetailsHash = newValue;
    });
  }

  getAddress(addressId: string): Address {
    if (this.addresses) {
      return this.addresses.filter(a => a.id === addressId)[0];
    } else {
      return null;
    }
  }

  getAddressV2(): string {
    if (this.orderDetail.shipToAddress) {
      const shipAddress = this.orderDetail.shipToAddress;
      const displayAddress = [];
      
      if(shipAddress.address1) displayAddress.push(shipAddress.address1);
      if(shipAddress.address2) displayAddress.push(shipAddress.address2);
      if(shipAddress.address3) displayAddress.push(shipAddress.address3);
      if(shipAddress.city) displayAddress.push(shipAddress.city);
      if(shipAddress.region) displayAddress.push(shipAddress.region);
      if(shipAddress.country) displayAddress.push(shipAddress.country);
      if(shipAddress.postalCode) displayAddress.push(shipAddress.postalCode);

      return displayAddress.join(', ');
    } else {
      return 'To Be Determined';
    }
  }

  showSummary() {
    this.showBomTable = !this.showBomTable;
    if (this.showBomTable) {
      this.projectService.getBomLines(this.worksheet.bomId).subscribe(response => {
        this.bomData = response;
        this.bomTableService.toTableBomRowsV2(response, this.market.accountNumber)
          .subscribe(rows => {
            this.bomItems = rows;
            this.skuDetailLoading = false;
          });
      }
      );

    }
  }

  downloadCopy() {
    const modalRef = this.modalService.open(DownloadCopyComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.worksheetId = this.worksheetId;
    modalRef.result
      .then(() => { })
      .catch(() => { });
  }

  closeErrorMessage() {
    this.errorMessages$.next(undefined);
  }

  
  saveGerf() {
    if (this.gerf.valid) {
      this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'group-equipment-received-f-date', { Value: this.gerf.value ? this.gerf.value : '' }).subscribe(() => {
        this.grpEquipRecvdF = this.gerf.value;
        this.onUpdateSuccess('Ground Equipment Received(F)');
      }, error => {
        this.onUpdateError('Ground Equipment Received(F)');
      });
    }
  }

  saveGera() {
    if (this.gera.valid) {
      this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'group-equipment-received-a-date', { Value: this.gera.value ? this.gera.value : '' }).subscribe(() => {
        this.grpEquipRecvdA = this.gera.value;
        this.onUpdateSuccess('Ground Equipment Received(A)');
      }, error => {
        this.onUpdateError('Ground Equipment Received(A)');
      });
    }
  }

  saveMrDate() {
    if (this.mrd.valid) {
      this.preferencesService.setPreference('WORKSHEET', this.worksheet.id, 'mr-date', { Value: this.mrd.value ? this.mrd.value : '' }).subscribe(() => {
        this.mrDate = this.mrd.value;
        this.onUpdateSuccess('MR Date');
      }, error => {
        this.onUpdateError('MR Date');
      });
    }
  }

  private onUpdateSuccess(pref: string) {
    this.toastr.success(pref + ' saved!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateError(pref: string) {
    this.toastr.error('There was an error saving the ' + pref, 'Error!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  getDeliverySpeed(code: string) {
    switch (code) {
      case '00':
        return 'Same day Shipment Ground';
      case '01':
        return '1 Day Air';
      case '02':
        return '2 Day Air';
      case '03':
        return '3 Day Air';
      case '05':
        return '5 Day Ground';
      case '48':
        return '48 Hour Shipment Ground';
      case 'U7':
        return '7 Day Air';
      case 'PU':
        return 'Customer Pickup Same Day';
      case 'P1':
        return 'Customer Pickup Later';
      case '31':
        return '3rd Party/Collect 1 Day Air';
      case '32':
        return '3rd party/Collect 2 Day Air';
      case '33':
        return '3rd Party/Collect 3 Day Air';
      case '35':
        return '3rd Party/Collect 5 Day';
      case 'RE':
        return 'Returns';
      case 'CC':
        return 'Consignment Returns/Issues';
    }
  }

  changeAddress() {
    const modalRef = this.modalService.open(OrderAddressChangeModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.worksheet = this.worksheet;
    modalRef.result.then((newAddressId) => { 
      this.marketService.getAddresses(this.worksheet.project.marketId).subscribe(addresses => {
        this.addresses = addresses;
        this.worksheet.shipToAddressId = newAddressId;
        if (this.worksheet.shipToAddressId) {
          this.toBeDetermined = false;
          this.selectedAddress = this.getAddress(this.worksheet.shipToAddressId);
        }
        this.projectService.sendOrderAddressChangedNotification(this.worksheet.id, newAddressId).subscribe();
      });
    }).catch(() => {});
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-detail-view/order-detail-view.component.ts